export const formatCurrency = (n) => {
  const v = parseFloat(n) || 0;
  return '₹ ' + v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatDate = (d) => {
  if (!d) return '-';
  const dt = new Date(d);
  if (isNaN(dt)) return d;
  return dt.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const today = () => new Date().toISOString().split('T')[0];

export const monthStart = () => {
  const d = new Date(); d.setDate(1);
  return d.toISOString().split('T')[0];
};

export const daysBetween = (d1, d2) => {
  const ms = new Date(d2) - new Date(d1);
  return Math.round(ms / (1000 * 60 * 60 * 24));
};

// ============================================================================
// Approval workflow helpers (v1.5)
// ============================================================================

// Get current logged-in user from localStorage. Returns { id, name, email, role }
export const getCurrentUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch {
    return {};
  }
};

export const isAdminUser = () => getCurrentUser().role === 'admin';

// Can the current user modify (edit/delete) a given record?
// - Admins can always modify
// - Staff can modify only their OWN pending records (approved is locked)
export const canModifyRecord = (record) => {
  if (!record) return false;
  const u = getCurrentUser();
  if (u.role === 'admin') return true;
  if (record.approval_status === 'approved') return false;
  return String(record.created_by) === String(u.id);
};

// Render a tiny status badge for a record. Pass approval_status string.
// Returns { className, label, color } — used in tables.
export const approvalBadge = (status) => {
  if (status === 'approved') {
    return { className: 'badge-approved', label: 'Approved', color: '#059669', bg: '#d1fae5' };
  }
  if (status === 'pending') {
    return { className: 'badge-pending', label: 'Pending', color: '#d97706', bg: '#fef3c7' };
  }
  return { className: 'badge-unknown', label: status || '-', color: '#64748b', bg: '#f1f5f9' };
};
